<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <div v-if="!loading && items.length">
        <template v-for="(item, keyItems) in items">
          <ServiceCard
            :key="keyItems"
            v-bind="item"
            :color="keyItems % 2 === 0 ? '#f0f8fc' : ''"
            :justify="keyItems % 2 !== 0 ? 'end' : 'start'"
          />
        </template>
      </div>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import ServiceCard from "../cards/ServiceCard.vue";

const _config = {
  mod: "services",
};

export default {
  data: () => ({
    loading: true,
  }),
  created() {
    this.$rest(_config.mod)
      .get()
      .then(() => (this.loading = false));
  },
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(
        ({ img, video, title, topics, text }) => ({
          img,
          video,
          title,
          topics: !topics ? [] : JSON.parse(topics),
          text,
        })
      );
    },
  },
  components: {
    LoadingWidget,
    ServiceCard,
  },
};
</script>
